import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { MainNavBar } from '../mainNavBar/MainNavBar';
import logoUrl from '../../../styles/assets/811-logo.png';
import keyLogo from './assets/nei_logo_2x.png';
import playButton from './assets/playButton.png';
import * as routePaths from '../../routePaths';
import ModalPopup from '../../common/modalPopup/modalPopup';


import './largeHeader.scss';


/**
 * The MainNavBar component.
 */
export class LargeHeader extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
    this.playVideo = this.playVideo.bind(this);
    this.stopVideo = this.stopVideo.bind(this);
    this.state= {
      mainVideoIsPlaying: false,
      popupIsActive: false,
      displayExitIntent: false,
      userClickedToView: false,
      autoPlay: '',
    }

  }

  componentWillMount() {
    const hasVisited = localStorage.getItem('hasVisited');

    if(hasVisited !=='yes'){
      console.log('new user')
      setTimeout( ()=> {
        this.refs.imgModalBtn.click();
      },7000);

      localStorage.setItem("hasVisited","yes");

    }

    else{
       console.log('user has been here before')
    }




  }

  componentDidMount(){
    var videoNotYetShown = true;



    window.addEventListener("resize", this.updateDimensions);
    setTimeout(() => {
      document.addEventListener("mouseout", function(event){


        if(videoNotYetShown && ((event.toElement ===null && event.relatedTarget===null) || event.y<=0))
        {
         document.getElementById('exitModalBtn').click();
          videoNotYetShown = false;
        }
      });
    }, 5000);



    setTimeout(() => {
      document.addEventListener("mouseleave", function(event){


        if(event.clientY <= 0 &&videoNotYetShown)
        {
           document.getElementById('exitModalBtn').click();
          videoNotYetShown = false;
        }
      });
    }, 5000);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */

  playVideo() {



      this.refs.modalBtn.click();


      this.setState({mainVideoIsPlaying:true});





  }



  stopVideo(){

    var mainVideo = this.refs.mainVideo;
    var vidSrc = mainVideo.getAttribute('src');
    mainVideo.setAttribute('src','');
    mainVideo.setAttribute('src',vidSrc);
    this.setState({'mainVideoIsPlaying':false})
  }
  render() {

    console.log(this.state);
    var heroVisibility={
      display:'block'
    }



    const{
      mainVideoIsPlaying,
      popupIsActive
    } = this.state;




    return (
      <div id="large-header">
        <MainNavBar
          location={this.props.location}
          match={this.props.match}
        />

        <div className="hero-slider" style={heroVisibility} onClick={this.playVideo.bind(this)}>
          <img src={keyLogo} className="header-logo" height="150px" width="150px"/>
          <div className="videoOverlay">
            <h1 className="featureHeadline">Get Dirty</h1>
            <h2 className="featureHeadline-sub">Just Contact 811 First</h2>
            <img src={playButton} className="playButton" height="50px" width="50px" />
          </div>
          <button type="button" ref="modalBtn" id="modalBtn"className="btn btn-info btn-lg" data-toggle="modal" data-target="#modal-video">Open Modal</button>
        </div>





        <div className="container-fluid inset-container">
          <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1">
          </div>
        </div>
        <div className="modal fade modalWrapper"   id="modal-video" tabIndex="-1" role="dialog" aria-labelledby="modal-video-label" onClick={this.stopVideo.bind(this)}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=> this.setState({mainVideoIsPlaying:false})}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-video">
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe  ref="mainVideo" src="https://player.vimeo.com/video/305275639" width="750px" height="750px" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen="true"></iframe>
                </div>
                <div className="video-link-container">
                  <h2>Meet the experts and learn about the issues</h2>
                  <form action={routePaths.baseVideoPageRoute} method="get" className="videoPageLinkCtn">
                    <button className="btn btn-sm videoPageButtonLink">Meet the Experts</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <button type="button" ref="imgModalBtn" id="modalImgBtn"className="btn btn-info btn-lg" data-toggle="modal" data-target="#modal-img" onClick={()=>this.setState({popupIsActive:true})}>Open Modal</button>
        { !mainVideoIsPlaying &&
          <div className="modal fade"   id="modal-img" tabIndex="-1" role="dialog" aria-labelledby="modal-video-label">
          <div className="modal-dialog" role="document">
            <div className="modal-content" >

              <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                    aria-hidden="true">&times;</span>
                  </button>
              </div>

              <div className="modal-body"  data-dismiss="modal"  onClick={()=>this.playVideo()}>

              </div>
            </div>
          </div>
        </div>
        }
        { !popupIsActive && !mainVideoIsPlaying && <ModalPopup />}

      </div>
    );
  }
}

LargeHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.object,
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

export default LargeHeader;



// WEBPACK FOOTER //
// ./src/components/common/largeHeader/LargeHeader.js